import { ContentTypes, IContentTypeParseResult } from '../types/http';

export const NO_CONTENT = 'no-content';

export const NO_CONTENT_TYPE_PARSE_RESULT: IContentTypeParseResult = {
  type: NO_CONTENT,
  subtype: NO_CONTENT,
  rest: NO_CONTENT,
};

export const CONTENT_TYPE_REGEX = /([a-z]+)\/([a-z0-9][a-z0-9!#$&^_.+-]*)(?:;\s*(.+))?/i;

export const CONTENT_TYPES: ContentTypes[] = ['text', 'multipart', 'message', 'image', 'audio', 'video', 'application'];

export const IFRAME_PREVIEW_CAMPAIGN_ID = 'iframe';

export const CLAIM_SUCCESS_STATUSES = [200, 201, 204];
